import React from 'react'
import classNames from 'classnames'

import Link from 'content-components/_Primatives/Link'
import style from './style.scss'

export type Variant =
  | 'primary'
  | 'primaryBlue'
  | 'primaryBlack'
  | 'primaryGreen'
  | 'primaryGray'
  | 'primaryYellow'
  | 'secondary'
  | 'secondaryBlack'
  | 'secondaryWhite'
  | 'secondaryBlue'

export type Props = {
  variant?: Variant
  url?: string
  type?: 'button' | 'submit'
} & Omit<React.HTMLProps<HTMLButtonElement | HTMLAnchorElement>, 'ref'>

function Button(props: Props) {
  const { className, type, url, variant = 'primary', ...rest } = props

  if (url) {
    return (
      <Link
        className={classNames(style[variant], className)}
        url={url}
        {...rest}
      />
    )
  } else {
    return (
      <button
        type={type}
        className={classNames(style[variant], className)}
        {...rest}
      />
    )
  }
}

export default Button
